import React, { FC } from 'react';
import HotelForm from '../HotelForm';
import { useMutation } from '@apollo/client';
import { CREATE_HOTEL } from '../graphql/mutations';
import useNotifications from '../../../Notifications/useNotifications';
import { HotelInput } from '../HotelForm/types';
import { GET_HOTELS } from '../graphql/queries';
import { useNavigate } from 'react-router';

const NewHotel: FC = () => {
  const { addError, addSuccess } = useNotifications();
  const navigate = useNavigate();
  const [createHotel] = useMutation(CREATE_HOTEL, {
    onCompleted: () => {
      addSuccess('Hotel created successfully.');
      navigate('/hotels');
    },
    onError: () => addError('Error creating hotel. Please try again.'),
    refetchQueries: [{ query: GET_HOTELS }],
    awaitRefetchQueries: true
  });

  const onSubmit = async (values: HotelInput) => {
    await createHotel({ variables: { values } });
  };
  return (
    <>
      <h1 className="my-6 text-3xl">New hotel</h1>
      <HotelForm onSubmit={onSubmit} />
    </>
  );
};

export default NewHotel;
